import * as React from "react";
import PropTypes from 'prop-types';

const SvgAccountIconFilled = props => {
  if (props.id !== "_svgaccounticonfilled") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M16 28.8c7.07 0 12.8-5.73 12.8-12.8S23.07 3.2 16 3.2 3.2 8.93 3.2 16 8.93 28.8 16 28.8zm5.6-7.2c.828.384 1.6.8 1.6 1.6S20 26.4 16 26.4 8.8 24 8.8 23.2c0-.79.804-1.197 1.573-1.587l.027-.013 2.585-1.396c.304-.154.481-.43.481-.719v-.27c-1.438-1.008-2.343-2.891-2.343-4.967 0-3.135 2.055-5.715 4.648-5.715 2.592 0 4.649 2.58 4.649 5.715 0 2.01-.85 3.843-2.215 4.873v.393c0 .301.187.582.511.733L21.6 21.6z" fill="#202020" /></svg>;
};

SvgAccountIconFilled.displayName = "_svgaccounticonfilled";
SvgAccountIconFilled.propTypes = {
  id: PropTypes.string
};
SvgAccountIconFilled.defaultProps = {
  id: ''
};
export default SvgAccountIconFilled;